import React, { Component } from 'react'
import _ from 'lodash'
import { request } from '../utils/http'
import custom from '../config/custom'
import { getAttributeType } from '../utils/models'

const debounceTime = 300

export default (WrappedComponent) => {

    return class extends Component {

        handleChange = _.debounce(() => {

            let value = this.props.form.getFieldValue(this.props.attribute)

            const error = this.props.form.getFieldError(this.props.attribute)

            if (value === undefined) {
                value = null
            }

            switch (getAttributeType(this.props.model, this.props.attribute)) {
                case 'time':
                    if (value) {
                        value = value.format('HH:mm:ss')
                    }
                    break

                case 'date':
                    if (value) {
                        value = value.format('YYYY-MM-DD')
                    }
                    break

                case 'datetime':
                    if (value) {
                        value = value.format('YYYY-MM-DD HH:mm:ss')
                    }
                    break

                default:
                    break
            }

            if (this.props.hasOwnProperty('onChange')) {
                this.props.onChange(value)
            }

            const getValues = (key, v) => {
              if (key === 'customer') {
                return {
                  customer: this.props.filter.or[0].id,
                  customerTaxIdRegistrationNumber: null,
                  customerTaxResidence: null,
                };
              }
              return { [key]: v };
            }

            if (this.props.autoSave &&
                this.props.id &&
                !error) {
                request(`${custom.baseUrl}/${this.props.model}/${this.props.id}`, {
                    method: 'PATCH',
                    data: getValues(this.props.attribute, value)
                })
                    .then(() => {
                        //
                    })
                    .catch(() => {
                        //
                    })
            }
        }, this.props.hasOwnProperty('delayTime') ? this.props.delayTime : debounceTime)

        render() {
            return <WrappedComponent handleChange={this.handleChange} {...this.props} />
        }
    }
}



// WEBPACK FOOTER //
// ./src/hocs/withHandleChange.js